import React, { useEffect, useState } from 'react';
import './ChristmasDecor.css';

const ChristmasDecor = () => {
  const [lights, setLights] = useState([]);
  const [snowflakes, setSnowflakes] = useState([]);

  useEffect(() => {
    // Generate lights across top
    const numberOfLights = 40;
    const generatedLights = [];
    
    for (let i = 0; i < numberOfLights; i++) {
      generatedLights.push({
        id: i,
        color: getRandomColor(),
        delay: Math.random() * 2,
        left: (i * (100 / numberOfLights)) + (Math.random() * 2)
      });
    }
    
    setLights(generatedLights);

    // Generate snowflakes
    const numberOfSnowflakes = 30;
    const generatedSnowflakes = [];
    
    for (let i = 0; i < numberOfSnowflakes; i++) {
      generatedSnowflakes.push({
        id: i,
        left: Math.random() * 100,
        animationDuration: 8 + Math.random() * 12,
        animationDelay: Math.random() * 10,
        fontSize: 12 + Math.random() * 16,
        opacity: 0.4 + Math.random() * 0.6
      });
    }
    
    setSnowflakes(generatedSnowflakes);
  }, []);

  const getRandomColor = () => {
    const colors = ['red', 'blue', 'green', 'yellow', 'orange', 'pink', 'white'];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  return (
    <div className="christmas-decor-wrapper">
      {/* Lights across top */}
      <div className="christmas-lights-login">
        <div className="christmas-wire-login"></div>
        {lights.map((light) => (
          <div
            key={light.id}
            className={`christmas-light-login ${light.color}`}
            style={{
              left: `${light.left}%`,
              animationDelay: `${light.delay}s`
            }}
          >
            <div className="light-bulb-login"></div>
            <div className="light-glow-login"></div>
          </div>
        ))}
      </div>

      {/* Snowflakes falling */}
      <div className="snow-container-login">
        {snowflakes.map((flake) => (
          <div
            key={flake.id}
            className="snowflake-login"
            style={{
              left: `${flake.left}%`,
              animationDuration: `${flake.animationDuration}s`,
              animationDelay: `${flake.animationDelay}s`,
              fontSize: `${flake.fontSize}px`,
              opacity: flake.opacity
            }}
          >
            ❄
          </div>
        ))}
      </div>

      {/* Christmas Tree - Left Corner */}
      <div className="christmas-tree left">
        <div className="tree-top">⭐</div>
        <div className="tree-body">🎄</div>
        <div className="tree-gifts">🎁</div>
      </div>

      {/* Christmas Tree - Right Corner */}
      <div className="christmas-tree right">
        <div className="tree-top">⭐</div>
        <div className="tree-body">🎄</div>
        <div className="tree-gifts">🎁</div>
      </div>

      {/* Floating decorations */}
      <div className="floating-decor snowman">☃️</div>
      <div className="floating-decor gift1">🎁</div>
      <div className="floating-decor gift2">🎁</div>
      <div className="floating-decor santa">🎅</div>
      <div className="floating-decor bell">🔔</div>
      <div className="floating-decor candy">🍬</div>
    </div>
  );
};

export default ChristmasDecor;
